// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ceycidjvcmwrtizqcmqt.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNleWNpZGp2Y213cnRpenFjbXF0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDI4MjMwNjIsImV4cCI6MjA1ODM5OTA2Mn0.IzwlmJJLtFYgspUnf0aeK8Ad4-prLjv7jPH3gN7CjVU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);